import { loadTossPayments } from "@tosspayments/tosspayments-sdk";
import { apiDelete, apiPost, apiPut } from "./apiClient";

const CLIENT_KEY = "test_ck_6bJXmgo28eEYxNB7mDvX8LAnGKWx";

/**
 * Toss 빌링 payment 객체를 초기화하여 반환합니다.
 * @returns {Promise<object>} payment 객체
 */
export async function initBillingPayment() {
  const userInfo = localStorage.getItem("user");
  const storeCode = JSON.parse(userInfo).storeCode;
  const tossPayments = await loadTossPayments(CLIENT_KEY);
  return tossPayments.payment({ customerKey: String(storeCode) });
}

/**
 * 카드 등록 인증 요청을 토스로 전송합니다. (현재 페이지 위에 토스 모달 표시)
 * @param {object} payment - initBillingPayment()로 받은 객체
 * @param {{ ownerEmail?: string, ownerNm?: string }} storeData
 * @param {boolean} isEdit - 카드 등록 모드인지 수정 모드인지 (true: 수정, false: 등록)
 */
export async function requestBillingAuth(payment, storeData, isEdit) {
  const mode = isEdit ? "edit" : "register";
  try {
    await payment.requestBillingAuth({
      method: "CARD",
      successUrl: window.location.origin + `/store/mypage?billing=success&billingMode=${mode}`,
      failUrl: window.location.origin + "/store/mypage?billing=fail",
      customerEmail: storeData?.ownerEmail || "customer@example.com",
      customerName: storeData?.ownerNm || "",
    });
  } catch (error) {
    // 사용자가 모달을 닫아 취소한 경우 에러를 무시
    if (error?.code === "USER_CANCEL" || error?.message?.includes("취소")) {
      return;
    }
    throw error;
  }
}

/**
 * 토스 성공 리다이렉트 후 쿼리파라미터에서 authKey/customerKey를 추출하여
 * 백엔드 빌링키 발급 API를 호출합니다.
 * @param {URLSearchParams} params - location.search 기반 파라미터
 * @returns {Promise<void>}
 */
export async function registerBillingKey(params) {
  const authKey = params.get("authKey");
  const customerKey = params.get("customerKey");
  const isEdit = params.get("billingMode") === "edit";

  // isEdit가 true면 기존 빌링키 수정, false면 신규 등록
  if (isEdit) {
    const res = await apiPut("/store/billing", { authKey, customerKey });
    
    if (!res.ok) {
      throw new Error("카드 수정 실패");
    }
    return res;
  } else {
    const res = await apiPost("/store/billing", { authKey, customerKey });
    
    if (!res.ok) {
      throw new Error("카드 등록 실패");
    }
    return res;
  }
}

/**
 * 등록된 빌링키(카드)를 삭제합니다.
 * @returns {Promise<void>}
 */
export async function deleteBillingKey() {
  const res = await apiDelete("/store/billing");
  if (!res.ok) {
    throw new Error("카드 삭제 실패");
  }
  return res;
}
